import { Component } from '@angular/core';

@Component({
  selector: 'signs-portal',
  templateUrl: './signs-portal.component.html',
  styleUrls: ['./signs-portal.component.scss']
})
export class SignsPortalComponent {}
